import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { HttpClientModule } from "@angular/common/http";
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

import { NgxImageCompressorModule } from 'ngx-image-compressor';

import { TitleCasePipe, DatePipe, CurrencyPipe } from '@angular/common';



@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [BrowserModule, IonicModule.forRoot(), AppRoutingModule,HttpClientModule, NgxDatatableModule, NgxImageCompressorModule],
  providers: [{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy },TitleCasePipe, DatePipe, CurrencyPipe],
  bootstrap: [AppComponent],
})
export class AppModule {}
